import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Plus, User, FileText, Stethoscope, Bell, ChevronRight } from 'lucide-react';
import { familyMembers, mockTimelineRecords } from '../../data/mockData';
export function FamilyCareFlow() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [selectedMember, setSelectedMember] = useState<any>(null);
  const [showAddForm, setShowAddForm] = useState(false);
  const handleSelectMember = (member: any) => {
    setSelectedMember(member);
    setStep(2);
  };
  return <div className="min-h-screen bg-slate-50 flex flex-col" data-id="element-466">
      <div className="bg-white px-6 pt-12 pb-4 shadow-sm sticky top-0 z-10 flex items-center justify-between" data-id="element-467">
        <div className="flex items-center gap-3" data-id="element-468">
          <button onClick={() => step === 2 ? setStep(1) : navigate(-1)} className="p-2 -ml-2 hover:bg-slate-50 rounded-full" data-id="element-469">
            <ArrowLeft className="w-6 h-6 text-slate-700" data-id="element-470" />
          </button>
          <h1 className="text-xl font-bold text-slate-900" data-id="element-471">
            {step === 1 ? 'Family Care' : selectedMember?.name}
          </h1>
        </div>
        {step === 1 && !showAddForm && <button onClick={() => setShowAddForm(true)} className="p-2 text-green-600 hover:bg-green-50 rounded-full" data-id="element-472">
            <Plus className="w-5 h-5" data-id="element-473" />
          </button>}
      </div>

      <div className="p-6 flex-1 overflow-y-auto" data-id="element-474">
        {step === 1 && <motion.div initial={{
        opacity: 0,
        x: -10
      }} animate={{
        opacity: 1,
        x: 0
      }} className="space-y-4" data-id="element-475">
            {showAddForm ? <div className="bg-white p-5 rounded-2xl shadow-sm border border-slate-100" data-id="element-476">
                <h2 className="font-semibold text-slate-900 mb-4" data-id="element-477">
                  Add Family Member
                </h2>
                <div className="space-y-4" data-id="element-478">
                  <input type="text" className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-sm" placeholder="Full Name" data-id="element-479" />
                  <input type="number" className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 text-sm" placeholder="Age" data-id="element-480" />
                  <div className="flex gap-3 pt-2" data-id="element-481">
                    <button onClick={() => setShowAddForm(false)} className="flex-1 py-3 rounded-xl border border-slate-200 text-slate-700 font-medium text-sm" data-id="element-482">
                      Cancel
                    </button>
                    <button onClick={() => setShowAddForm(false)} className="flex-1 py-3 rounded-xl bg-green-600 text-white font-medium text-sm" data-id="element-483">
                      Save
                    </button>
                  </div>
                </div>
              </div> : familyMembers.map(member => <button key={member.id} onClick={() => handleSelectMember(member)} className="w-full bg-white p-4 rounded-2xl shadow-sm border border-slate-100 flex items-center justify-between hover:border-green-200 transition-colors" data-id="element-484">
                  <div className="flex items-center gap-4" data-id="element-485">
                    <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center" data-id="element-486">
                      <User className="w-6 h-6 text-green-600" data-id="element-487" />
                    </div>
                    <div className="text-left" data-id="element-488">
                      <h3 className="font-bold text-slate-900" data-id="element-489">
                        {member.name}
                      </h3>
                      <p className="text-sm text-slate-500" data-id="element-490">
                        {member.relation} • {member.age} yrs
                      </p>
                    </div>
                  </div>
                  <ChevronRight className="w-5 h-5 text-slate-400" data-id="element-491" />
                </button>)}
          </motion.div>}

        {step === 2 && selectedMember && <motion.div initial={{
        opacity: 0,
        x: 10
      }} animate={{
        opacity: 1,
        x: 0
      }} className="space-y-6" data-id="element-492">
            <div className="grid grid-cols-3 gap-3" data-id="element-493">
              <button onClick={() => navigate('/flow/book-doctor')} className="bg-white p-3 rounded-xl shadow-sm border border-slate-100 flex flex-col items-center text-center hover:bg-green-50" data-id="element-494">
                <Stethoscope className="w-5 h-5 text-green-600 mb-1" data-id="element-495" />
                <span className="text-xs font-medium text-slate-700" data-id="element-496">
                  Book Doctor
                </span>
              </button>
              <button onClick={() => navigate('/records')} className="bg-white p-3 rounded-xl shadow-sm border border-slate-100 flex flex-col items-center text-center hover:bg-green-50" data-id="element-497">
                <FileText className="w-5 h-5 text-green-600 mb-1" data-id="element-498" />
                <span className="text-xs font-medium text-slate-700" data-id="element-499">
                  Records
                </span>
              </button>
              <button className="bg-white p-3 rounded-xl shadow-sm border border-slate-100 flex flex-col items-center text-center hover:bg-green-50" data-id="element-500">
                <Bell className="w-5 h-5 text-green-600 mb-1" data-id="element-501" />
                <span className="text-xs font-medium text-slate-700" data-id="element-502">
                  Reminder
                </span>
              </button>
            </div>

            <div data-id="element-503">
              <h3 className="font-semibold text-slate-900 mb-4" data-id="element-504">
                Health Timeline
              </h3>
              <div className="space-y-4 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px before:h-full before:w-0.5 before:bg-slate-200" data-id="element-505">
                {mockTimelineRecords.map(record => <div key={record.id} className="relative flex items-center gap-4" data-id="element-506">
                    <div className="w-10 h-10 rounded-full border-4 border-white bg-green-100 flex items-center justify-center z-10 shadow-sm" data-id="element-507">
                      <FileText className="w-4 h-4 text-green-600" data-id="element-508" />
                    </div>
                    <div className="flex-1 bg-white p-3 rounded-xl border border-slate-100 shadow-sm" data-id="element-509">
                      <div className="flex justify-between items-center mb-1" data-id="element-510">
                        <span className="text-xs font-medium text-slate-500" data-id="element-511">
                          {record.type}
                        </span>
                        <span className="text-xs text-slate-400" data-id="element-512">
                          {record.date}
                        </span>
                      </div>
                      <h4 className="font-bold text-slate-900 text-sm" data-id="element-513">
                        {record.title}
                      </h4>
                    </div>
                  </div>)}
              </div>
            </div>
          </motion.div>}
      </div>
    </div>;
}